import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useApp } from '../../contexts/AppContext';

const Breadcrumbs = () => {
  const location = useLocation();
  const { breadcrumbs } = useApp();

  // Generar breadcrumbs automáticamente si no están definidos en el contexto
  const generateBreadcrumbs = () => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const breadcrumbItems = [{ name: 'Inicio', path: '/home' }];

    let currentPath = '';
    pathSegments.forEach((segment, index) => {
      currentPath += `/${segment}`;
      
      // Mapear rutas a nombres legibles
      const segmentNames = {
        home: 'Inicio',
        projects: 'Proyectos',
        users: 'Usuarios',
        courses: 'Cursos',
        evaluations: 'Evaluaciones',
        grades: 'Notas',
        calendar: 'Calendario',
        messages: 'Mensajería',
        finances: 'Finanzas',
        reports: 'Reportes'
      };

      const name = segmentNames[segment] || segment.charAt(0).toUpperCase() + segment.slice(1);
      
      breadcrumbItems.push({
        name,
        path: currentPath,
        isLast: index === pathSegments.length - 1
      });
    });

    return breadcrumbItems;
  };

  const items = breadcrumbs.length > 0 ? breadcrumbs : generateBreadcrumbs();

  // No mostrar breadcrumbs en la página de inicio principal
  if (location.pathname === '/home' || location.pathname === '/') {
    return null;
  }

  return (
    <nav className="bg-white border-b border-gray-200 px-4 sm:px-6 lg:px-8 py-3">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center space-x-2 text-sm">
          {items.map((item, index) => (
            <div key={item.path} className="flex items-center">
              {index > 0 && (
                <svg
                  className="w-4 h-4 text-gray-400 mx-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              )}
              
              {item.isLast ? (
                <span className="text-gray-500 font-medium">
                  {item.name}
                </span>
              ) : (
                <Link
                  to={item.path}
                  className="text-gray-600 hover:text-gray-900 transition-colors duration-200"
                >
                  {item.name}
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Breadcrumbs;